import pushModel from "../../mixin/store/api/pushModel";
import fetchModels from "@/mixin/store/api/fetchModels";
import fetchModel from "@/mixin/store/api/fetchModel";

export default {
    actions: {
        pushModifyProduct(context, data) {
            return pushModel(context, 'modified_products', data)
        },
        fetchModifyProducts(context, search) {
            return fetchModels(context, 'modified_products?', search.page + '&order[id]=desc', 'updateModifiedProducts');
        },
        fetchModifyProductDetails(context, modifyId) {
            return fetchModel(context, 'modified_products', modifyId, 'updateModifyProductDetails');
        },
        setModifyProductDetails(context, data) {
            context.commit('updateModifyProductDetails', data)
        },
    },
    mutations: {
        updateModifiedProducts(state, data) {
            state.modifiedProducts = data
        },
        updateModifyProductDetails(state, data) {
            state.modifyProductDetails = data
        }
    },
    state: {
        modifiedProducts: {
            models: [],
            totalItems: 0,
        },
        modifyProductDetails: {
            id: null,
            amount: null,
            prognosisRate: null,
            difference: null,
            modifiedProductItems: [],
        }
    },
    getters: {
        getModifiedProducts(state) {
            return state.modifiedProducts.models
        },
        getModifiedProductsTotalCount(state) {
            return state.modifiedProducts.totalItems
        },
        getModifyProductDetails(state) {
            return state.modifyProductDetails
        },
    },
}
